import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect
} from "react";

export type MflBlVisibilityState = {
  isMflBL: boolean;
  isMyQueueVisible: boolean;
};

const STORAGE_KEY = "mfl_bl_visibility_state";

const defaultState: MflBlVisibilityState = {
  isMflBL: false,
  isMyQueueVisible: false
};

const getInitialState = (): MflBlVisibilityState => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error(
      "Error reading MflBlVisibility state from localStorage:",
      error
    );
  }
  return defaultState;
};

type MflBlVisibilityContextType = {
  state: MflBlVisibilityState;
  setState: (next: MflBlVisibilityState) => void;
};

const MflBlVisibilityContext = createContext<MflBlVisibilityContextType>({
  state: defaultState,
  setState: () => {}
});

export const MflBlVisibilityProvider: React.FC<{ children: ReactNode }> = ({
  children
}) => {
  const [state, setState] = useState<MflBlVisibilityState>(getInitialState);

  // Persist state to localStorage whenever it changes
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
      console.error(
        "Error saving MflBlVisibility state to localStorage:",
        error
      );
    }
  }, [state]);

  return (
    <MflBlVisibilityContext.Provider value={{ state, setState }}>
      {children}
    </MflBlVisibilityContext.Provider>
  );
};

export const useMflBlVisibility = () => {
  const { state } = useContext(MflBlVisibilityContext);
  return state;
};

export const useSetMflBlVisibility = () => {
  const { setState } = useContext(MflBlVisibilityContext);
  return setState;
};
